import classNames from 'classnames';
import React, { useCallback, useEffect, useRef } from 'react'

type Props = {
  className?: string;
  children: string;
}

const MINIMUM_SIZE = 9;

export default function TextResizer({ children, className }: Props) {
  const resizerRef = useRef<HTMLParagraphElement>(null);

  const updateFontSize = useCallback(() => {
    if (resizerRef.current) {
      if (children.length >= 60) {
        const percentage = children.length / 60;
        const fontSize = getComputedStyle(resizerRef.current).fontSize;
        const size = parseFloat(fontSize);
        const resized = size - percentage;
        if (resized < MINIMUM_SIZE) resizerRef.current.style.fontSize = `${MINIMUM_SIZE}px`;
        else resizerRef.current.style.fontSize = `${resized}px`;
      }
      else resizerRef.current.style.fontSize = "unset";
    }
  }, [resizerRef, children]);

  useEffect(() => {
    updateFontSize();
  }, [children, updateFontSize]);

  return <p className={classNames("text-resizer mb-0", className)} ref={resizerRef}>{children}</p>;
}